const defaultProcessText = text => {
  const trimmed = text.replace(/(^ +)|( +$)/, '')

  const firstWordMatch = trimmed.match(/^(\W+)(\w+)|^(\w+)/i)
  const lastWordMatch = trimmed.match(/(\w+)(\W+)$|(\w+)$/i)

  const lastWord = lastWordMatch ? lastWordMatch[2] || lastWordMatch[3] : ''
  const firstWord = firstWordMatch ? firstWordMatch[2] || firstWordMatch[3] : ''

  const withoutFirstWord = firstWordMatch ? trimmed.slice(firstWordMatch[0].length).trim() : ''
  const withoutLastWord = lastWordMatch
    ? trimmed.slice(0, Math.max(0, trimmed.length - lastWordMatch[0].length)).trim()
    : ''

  return {
    text,
    trimmed,
    firstWord,
    firstWordCI: firstWord.toLowerCase(),
    lastWord,
    lastWordCI: lastWord.toLowerCase(),
    withoutFirstWord,
    withoutFirstWordCI: withoutFirstWord.toLowerCase(),
    withoutLastWord,
    withoutLastWordCI: withoutLastWord.toLowerCase(),
    lower: trimmed.toLowerCase(),
    upper: trimmed.toUpperCase(),
    endsWith: { letter: !/\s$/g.test(text) },
    startsWithLetter: !/^\s/g.test(text)
  }
}

export default defaultProcessText
